import React from "react";
import sortDatesDesc from "../../genericFunctions/sortDatesDesc";
import getProfileLabel from "../../genericFunctions/getProfileLabel";
const PrintEducationPage = (props) => {
  const educations = props.educations;
  const label = (key) => getProfileLabel(props.language, key);

  return (
    <div
      className="print-font"
      style={{
        paddingRight: "15px",
        borderTop: "1px solid #fff",
        marginTop: "40px",
        maxWidth: "100%",
      }}
    >
      <h3
        style={{
          marginBottom: "5px ",
          background: "#ffffff",
        }}
      >
        {label("education")}
        <div className="print-border"></div>
      </h3>
      <div
        style={{
          paddingBottom: "0px",
        }}
      >
        {educations.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {label("noEducations")}
          </p>
        ) : (
          educations
            .sort((a, b) =>
              sortDatesDesc(new Date(a.fromDate), new Date(b.fromDate))
            )
            .map((education) => {
              return (
                <div
                  key={education._id}
                  style={{
                    borderTop: "1px solid #fff",
                    borderBottom:
                      education !== educations[educations.length - 1]
                        ? "1px solid #e1e1e1"
                        : "",
                    padding: "0px",
                    pageBreakInside: "avoid",
                  }}
                >
                  <h4
                    style={{
                      margin: "0px 0px",
                      padding: "0px",
                      maxWidth: "100%",
                      fontSize: "15pt",
                    }}
                  >
                    {education.name}
                  </h4>
                  <p
                    style={{
                      fontStyle: "italic",
                      color: "dark-grey",
                      fontSize: "10pt",
                      margin: "0px 0px 0px 0px",
                    }}
                  >
                    {education.fromDate !== null
                      ? education.fromDate.slice(0, 7)
                      : label("missingDate")}
                    -
                    {education.toDate !== null
                      ? education.toDate.slice(0, 7)
                      : label("present")}
                  </p>
                  <p style={{ fontSize: "12pt" }}>{education.school}</p>
                </div>
              );
            })
        )}
      </div>
    </div>
  );
};

export default PrintEducationPage;
